module.exports = __webpack_public_path__ + "img/arrow-down.9693a60a.svg";